import * as React from 'react';
import ReactGA from 'react-ga';
import Result from "../Components/Result";
import { RouteComponentProps} from "react-router";
import {useState} from "react";
import {useEffect} from "react";

interface MatchParams {
    id? : string | undefined;
}

interface ResultProps extends RouteComponentProps<MatchParams> {
}

const analyticsId = 'G-EK0Y8CQQZH';

declare const window: any;
declare const gtag: any;
declare const fbq: any;


export const initGA = () => {
    window.dataLayer = window.dataLayer || [];
    gtag('js', new Date());
    gtag('config', analyticsId , {
        page_title: 'Test_Result',
        page_location: '/result',
        page_path: '/result'
    })
    fbq('track', 'Test_Result' , {
        value: '/result'
    });
};

initGA();


const ResultPage: React.FC<ResultProps> = ({match}) => {

    const type:string = String(match.params.id);

    return (
        <Result
            type={type}
        />
    );
};

export default ResultPage;